/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

/**
 * Inline SVG class that takes a HTMLImageElement and renders the associated svg.
 * This class is used in conjunction with the SvgRender directive.
 * @see /directives/SvgRender
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class InlineSvg {
    /**
     * Execute the transition
     */
    public static execute(svg: HTMLImageElement): void {
        InlineSvg.getSvg(svg, svg.src);
    }

    /**
     * @param {HTMLImageElement} source
     * @param {HTMLElement} target
     */
    public static replace(source: HTMLImageElement, target: HTMLElement): void {
        // add replaced image's ID to the new SVG
        if (typeof source.id !== 'undefined') {
            target.id = source.id;
        }

        target.classList.add('replaced-svg');

        // remove any invalid XML tags as per http://validator.w3.org
        target.removeAttribute('xmlns:a');

        // replace image with new SVG
        source.replaceWith(target);
    }

    /**
     * @param {HTMLImageElement} source
     * @param {string} url
     */
    public static getSvg(source: HTMLImageElement, url: string): void {
        source.src = '';
        const http: XMLHttpRequest = new XMLHttpRequest();
        http.open('GET', url, true);
        http.setRequestHeader('Content-Type', 'text/xml; charset=UTF-8');
        http.onload = (): void => {
            if (http.readyState === http.DONE && http.status === 200 && null !== http.responseXML) {
                const target: HTMLElement = http.responseXML.documentElement;
                InlineSvg.replace(source, target);
            }
        };
        http.send(null);
    }
}
